import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useDispatch, useSelector } from 'store';
import { closeModal } from 'store/modals';
import Button from 'components/Button/Button';
import Modal from 'components/Modal/Modal';
import QuestionStatus from 'types/QuestionStatus';

import './KliparoElementSubmittedModal.scss';
import { useNavigate } from 'react-router-dom';

export interface TraroElementSubmittedModalProps {
  questionStatus: QuestionStatus;
}

const KliparoElementSubmittedModal: FC<TraroElementSubmittedModalProps> = ({ questionStatus }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const isOpen = useSelector((store) => store.modals.traroElementSubmitModal.open);
  const rfpId = useSelector((store) => store.rfp.data.id);
  const rfpResponseId = useSelector((store) => store.rfpResponse.data.id);

  const handleCloseModal = useCallback(() => {
    dispatch(closeModal('traroElementSubmitModal'));
  }, [dispatch]);

  const handleGoToOverview = useCallback(() => {
    dispatch(closeModal('traroElementSubmitModal'));
    navigate(`/rfp/${rfpId}/rfp-response/${rfpResponseId}`);
  }, [dispatch, navigate, rfpId, rfpResponseId]);

  return (
    <Modal
      isOpen={isOpen}
      variant="kliparo"
      className="enkrateia-kliparo-element-submitted-modal"
      title={t('pages.traroElement.modalTitle.criterionSet', {
        status: t(`common.kliparoStatusMap.${questionStatus}`),
      })}
    >
      <div className="modal-content">
        <Button variant="primary" onClick={handleCloseModal}>
          {t('common.ok')}
        </Button>
        <Button variant="light-grey-filled" onClick={handleGoToOverview}>
          {t('pages.traroElement.goToOverview')}
        </Button>
      </div>
    </Modal>
  );
};

export default KliparoElementSubmittedModal;
